import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router';
import { PartnerCompany } from 'api/partner/types';
import { NewPartnerDrawer } from 'components/organisms/module-settings/partner';
import { RoutePaths } from 'constant';

export const NewPartner: FC<{
  onPartnerCreate?: (partner: PartnerCompany) => void;
}> = ({ onPartnerCreate }) => {
  const { push } = useHistory();
  const goToListPage = useCallback(() => push(RoutePaths.partner), [push]);

  return (
    <NewPartnerDrawer
      visible
      onClose={goToListPage}
      onPartnerCreate={onPartnerCreate}
    />
  );
};
